import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {toast} from 'react-toastify'
import {
  generateMfaOtp,
  verifyMfaOtp,
} from 'setup/redux/Actions/UserSecurityDetails/userSecurityDetails'

import MultiFactorAuthModal from './MultiFactorAuthModal'

interface UserDetails {
  userEmail: string
  userId: string
  userPassword: string
}

interface MultiFactorAuthProps {
  showModal: boolean
  closeModal: () => void
  userDetails: UserDetails
  onModalError: (message: string) => void
  proceedLogin: (
    email: string,
    password: string,
    setSubmitting?: (isSubmitting: boolean) => void,
    setStatus?: (status: string) => void
  ) => void
  setSubmitting?: (isSubmitting: boolean) => void
  setStatus?: (status: string) => void
}

const MultiFactorAuth = ({
  showModal,
  closeModal,
  userDetails,
  onModalError,
  proceedLogin,
  setSubmitting,
  setStatus,
}: MultiFactorAuthProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(true)

  const generateOtp = () => {
    const payload = {
      email: userDetails?.userEmail,
      userId: userDetails?.userId,
    }

    const onSuccess = () => {
      setIsLoading(false)
      toast.success(intl.formatMessage({id: 'OTP_CREATE.MESSAGE'}))
    }
    const onFailure = (res: any) => {
      setIsLoading(false)
      onModalError(res?.message)
    }

    dispatch(generateMfaOtp(payload, onSuccess, onFailure))
  }

  useEffect(() => {
    generateOtp()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = (otp: string) => {
    const payload = {
      email: userDetails?.userEmail,
      userId: userDetails?.userId,
      otp,
    }

    const onSuccess = () => {
      setIsLoading(true)
      proceedLogin(userDetails?.userEmail, userDetails?.userPassword, setSubmitting, setStatus)
      closeModal()
    }
    const onFailure = (res: any) => {
      if (res.statusCode === 400) {
        toast.error(res?.message || intl.formatMessage({id: 'GENERAL.SOMETHING_WENT_WRONG'}))
      } else {
        onModalError(res?.message)
      }
    }
    dispatch(verifyMfaOtp(payload, onSuccess, onFailure))
  }

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center'>
        <div className='spinner-grow text-primary' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <>
      <MultiFactorAuthModal
        show={showModal}
        onHide={() => closeModal()}
        userDetails={userDetails}
        generateOtp={generateOtp}
        verifyOtp={handleSubmit}
      />
    </>
  )
}

export default MultiFactorAuth
